import React from 'react';

export default function Circle() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" />
    </svg>
  );
}
